module.exports = __webpack_public_path__ + "img/succeed.1fc95050.png";